import React, { Component, PropTypes } from "react";
import { Redirect } from "react-router";
import axios from "axios";
import StoreName from "./Store";
import Product from "./containers/ProductContainer";
import ProductList from "./containers/ProductList";
import { FETCH_STATUS } from "./constants";
import "./App.css";

class App extends Component {
  state = {
    selected: null,
    products: [],
    state: FETCH_STATUS.NOT_STARTED,
    filterText: ""
  };

  async componentWillMount() {
    await this.refresh(false);
  }

  refresh = async refresh => {
    try {
      const store = localStorage.getItem("tpt-store");
      this.setState({ status: FETCH_STATUS.REQUESTED });
      const response = await axios.get(
        `https://9x3p2gpkxc.execute-api.us-west-1.amazonaws.com/Prod/products?shop=${store}&refresh=${refresh}`
        //`http://localhost:4000/products?shop=${store}&refresh=${refresh}`
      );
      const products = response.data.sort(
        (a, b) => (a.title > b.title ? 1 : -1)
      );
      const selected = products.length > 0 ? products[0].id : null;
      this.setState({
        products,
        filtered: products,
        status: FETCH_STATUS.SUCCEEDED,
        selected,
        filterText: ""
      });
    } catch (e) {
      console.error(e);
      this.setState({ status: FETCH_STATUS.FAILED });
    }
  };

  handleSelectChange = (id, index) => {
    this.setState({ selected: id });
  };

  handleStoreChange = () => {
    localStorage.removeItem("tpt-store");
    this.forceUpdate();
  };

  onFilter = e => {
    const value = e.target.value;
    const filtered = this.state.products.filter(
      p => p.title.toLowerCase().indexOf(value.toLowerCase()) >= 0
    );
    this.setState({ filterText: value, filtered });
  };

  render() {
    const store = localStorage.getItem("tpt-store");
    const isPreview = window.location.href.indexOf("preview") >= 0;
    if (store == null) {
      return <StoreName />;
    }
    return (
      <div className="container">
        <header>
          <div className="flex">
            <h3>Bearwood Labs</h3> | Product Description PRO v1.5
          </div>
          <div className="flex">
            {store}{" "}
            <div className="clickable" onClick={this.handleStoreChange}>
              Change
            </div>
          </div>
        </header>

        <nav>
          <div className="store">
            <div className="flex">
              <h4>Products</h4>
              <div onClick={() => this.refresh(true)} className="clickable">
                <i className="ionicon ion-refresh" alt="refresh" />
              </div>
            </div>
            {!isPreview && (
              <input
                placeholder="Filter products.."
                type="text"
                onChange={this.onFilter}
                disabled={isPreview}
                value={this.state.filterText}
              />
            )}
          </div>
          {isPreview && (
            <div>
              <strong>Preview mode</strong> allows you to edit the first 3
              products of your store
            </div>
          )}
          <ProductList
            refresh={this.refresh}
            store={store}
            status={this.state.status}
            products={this.state.filtered}
            selected={this.state.selected}
            onProductChange={this.handleSelectChange}
          />
        </nav>

        <main>
          <div>
            <Product
              products={this.state.products}
              productId={this.state.selected}
              preview
            />
          </div>
        </main>

        <footer />
      </div>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js